import { useEffect, useState } from "react";
import { Button, Card, Col, Container } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ApiService from "../../../services/api";
import { Link } from "react-router-dom";

const MusicListDashboard = () => {
  const [music, setMusic] = useState([]);
  const [Loading, setLoading] = useState(true);

  const fetchMusicCompositions = async () => {
    const music = await ApiService.getLatestMusics();
    setMusic(music);
    setLoading(false);
  };

  useEffect(() => {
    fetchMusicCompositions();
  }, []);

  const columns = [
    {
      name: "Categoria",
      selector: (row) => row.category.name,
      center: "true",
      width: "33%",
    },
    {
      name: "Titolo",
      selector: (row) => row.title,
      center: "true",
      width: "33%",
    },
    {
      name: "Tipo",
      selector: (row) => (
        <div>
          {!row.link ? "File audio e video" : "Link esterno"}
        </div>
      ),
      center: "true",
      width: "34%",
    },
  ];

  if (Loading) {
    return;
  }

  return <>
    <div className="admin-card">
      <div className="admin-card-header">
        <div className="admin-card-icon admin-card-icon-news black-gradient">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-music-note" viewBox="0 0 16 16">
            <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2"/>
            <path fill-rule="evenodd" d="M9 3v10H8V3z"/>
            <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z"/>
          </svg>
        </div>
        <p><small>Ultimi contenuti musicali</small></p>
      </div>
      <hr className="divider-dark mb-0" />
      <div className="admin-card-content">
        <DataTable columns={columns} data={music} />
        <div className="mb-4 text-end">
          <a href="/admin/musicList" className="admin-link admin-card-view-more site-link">
            Visualizza tutti
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
            </svg>
          </a>
        </div>
        <Link
          to="/admin/musicCreate"
          className="w-100 btn btn-admin-dashboard-add btn-black-gradient"
          data-discover="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            className="bi bi-plus"
            viewBox="0 0 16 16"
          >
            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
          </svg>
          Inserisci contenuto musicale
        </Link>
      </div>
    </div>
  </>
};
export default MusicListDashboard;
